/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	CartMaxPayByBonusesCreateData,
	CartMaxPayByBonusesCreateStatus200,
	CartMaxPayByBonusesCreateStatus400,
	CartMaxPayByBonusesCreateStatus401,
	CartMaxPayByBonusesCreateStatus503,
} from "../types/CartMaxPayByBonusesCreate.ts";

function getCartMaxPayByBonusesCreateUrl() {
	const res = { method: "POST", url: `/api/cart/max-pay-by-bonuses/` as const };

	return res;
}

/**
 * @description Представление расчета максимального списания бонусов по корзине.
 * @summary расчет максимального списания бонусов по корзине.
 * {@link /api/cart/max-pay-by-bonuses/}
 */
export async function cartMaxPayByBonusesCreate(
	data: CartMaxPayByBonusesCreateData,
	config: Partial<RequestConfig<CartMaxPayByBonusesCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<
		CartMaxPayByBonusesCreateStatus200,
		ResponseErrorConfig<CartMaxPayByBonusesCreateStatus400 | CartMaxPayByBonusesCreateStatus401 | CartMaxPayByBonusesCreateStatus503>,
		CartMaxPayByBonusesCreateData
	>({ method: "POST", url: getCartMaxPayByBonusesCreateUrl().url.toString(), data: requestData, contentType, ...requestConfig });

	return res.data;
}
